import type { OptionDB } from "@project/emerge";
import { Sides } from "@project/emerge-types";
import { Covers } from "../enum/Covers";
import { LTCaseUserOption } from "../enum/LTCaseUserOption";
import { LTProducts } from "../enum/LTProducts";
import type { FlightCaseSettings } from "../interfaces/FlightCaseSettings";
import {
  createCoverOptions,
  createRack19Interior,
} from "../structure/RackInterior";
import { FlightCaseDefinition } from "./FlightCaseDefinition";

export class Case3d extends FlightCaseDefinition {
  public static getSerializedDefaultVersion(
    optionDb: OptionDB,
    options?: {
      alternativeCuts: boolean;
    },
  ): FlightCaseSettings {
    const result: FlightCaseSettings =
      FlightCaseDefinition.getSerializedDefaultVersion(optionDb);
    result.cuts = options?.alternativeCuts
      ? [
          {
            offset: 50,
            reference: Sides.BACK,
            groupName: Covers.BACK_COVER,
          },
          {
            offset: 50,
            reference: Sides.FRONT,
            groupName: Covers.FRONT_COVER,
          },
          {
            baseOnly: true,
            offset: 50,
            reference: Sides.TOP,
            groupName: Covers.TOP_COVER,
          },
        ]
      : [
          {
            offset: 50,
            reference: Sides.TOP,
            groupName: Covers.TOP_COVER,
          },
          {
            cutFrom: Sides.BOTTOM,
            offset: 50,
            reference: Sides.BACK,
            groupName: Covers.BACK_COVER,
          },
          {
            cutFrom: Sides.BOTTOM,
            offset: 50,
            reference: Sides.FRONT,
            groupName: Covers.FRONT_COVER,
          },
        ];
    result.interiorOptions = createRack19Interior(optionDb);
    result.type = LTProducts.Case3d;
    result.exteriorOptions.inlineCover = false;
    result.coverPaddings = createCoverOptions(optionDb, result.cuts);
    result.exteriorOptions.rollers = optionDb.getByName(
      LTCaseUserOption.RollerType,
      "AH 37600S rechts",
    );
    result.variableOptions = [];
    result.exteriorOptions.strength = 6.5;
    return result;
  }
}
